import React from "react";
import "../style/Hero.css";
import heroImg from "../../assets/hero.png";

const Hero = () => {
  return (
    <section className="hero"  style={{ backgroundImage: `url(${heroImg})` }}>
      <div className="hero-overlay"></div>

      <div className="hero-container">
        {/* Left Content */}
        <div className="hero-content">
          <h1>
            Your Trusted <br /> Logistics Partner
          </h1>
          <p>
            Reliable and efficient logistics solutions for your global shipping
            needs.
          </p>

          <div className="hero-buttons">
            <button className="btn-primary">Request a Quote</button>
            <button className="btn-secondary">Learn More</button>
          </div>
        </div>

        
      </div>
    </section>
  );
};

export default Hero;
